// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"91ef575a","510":"4f1a7b04","920":"6857ef80"}[chunkId] + ".chunk.css";
};